import { render, staticRenderFns } from "./TodayLoginsDialog.vue?vue&type=template&id=2053a75d"
import script from "./TodayLoginsDialog.vue?vue&type=script&lang=js"
export * from "./TodayLoginsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports